import { useEffect, useState } from 'react'
import { InputHintBehaviour } from '../../models/enums'

const useInputHintBehaviour = (instanceId?: string): InputHintBehaviour | undefined => {
  const [current, setCurrent] = useState<InputHintBehaviour | undefined>(undefined)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_inputHintBehaviour', (e) => handleChange(e))
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_inputHintBehaviour'))

    return () => {
      document.removeEventListener('retorik_inputHintBehaviour', (e) => handleChange(e))
    }
  }, [])

  return current
}

export default useInputHintBehaviour
